import type { SyncSnapshot } from "./types"
export type SavedProjection = SyncSnapshot & { offset: string; handle: string | null; cursor: string | null; savedAt: number }
const NAME = "setsail-screen-sync-1"
let opening: Promise<IDBDatabase> | undefined
function database() {
  return opening ??= new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(NAME, 1)
    request.onupgradeneeded = () => request.result.createObjectStore("screens")
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  }).catch(error => { opening = undefined; throw error })
}
export async function loadProjection(key: string): Promise<SavedProjection | undefined> {
  const db = await database()
  return new Promise((resolve, reject) => {
    const request = db.transaction("screens").objectStore("screens").get(key)
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}
export async function saveProjection(key: string, value: SavedProjection) {
  const db = await database()
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction("screens", "readwrite")
    tx.objectStore("screens").put(value, key)
    // Bound disk storage to the eight most recently used account/screen scopes.
    const request = tx.objectStore("screens").getAll()
    request.onsuccess = () => {
      const records = request.result as SavedProjection[]
      records.sort((a, b) => b.savedAt - a.savedAt)
      for (const record of records.slice(8)) tx.objectStore("screens").delete(`${record.manifest.viewer}:${record.manifest.scope}`)
    }
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
    tx.onabort = () => reject(tx.error)
  })
}
export async function clearSavedProjections() {
  const db = await database()
  await new Promise<void>((resolve, reject) => {
    const tx = db.transaction("screens", "readwrite")
    tx.objectStore("screens").clear()
    tx.oncomplete = () => resolve()
    tx.onerror = () => reject(tx.error)
  })
}
